// extracted by mini-css-extract-plugin
export default {"title":"uZ18TT0vhcHHOnB0bDdF","titleText":"jbKhONuLreGbl3_UOsUd","closeModal":"D2DebuVrlorJ3HB1EWac","rightGroup":"SYtQoX6JzWj2BPbkOhba","titleWrapper":"i5pWX6RRTXndkAN81Jt5"};